import { uniq } from "lodash";
import { CacheStore } from "./CacheStore/CacheStore";
import { UserStore } from "./UserStore/UserStore";

export class UserService {
  constructor(private cacheStore: CacheStore, private userStore: UserStore) {}

  getUserProfessions() {
    const extraProfessions = this.cacheStore.getProfessionsOnAreasofExp(
      this.userStore.myProfile.ExtraAreasOfExpertise.map((x) => x.Name)
    );

    const teams = this.userStore.myProfile.Teams;

    const profs = this.cacheStore.getProfessionsOnTeams(teams);

    return uniq([...profs, ...extraProfessions]);
  }
}
